export default function Hero() {
  const goTo = (href: string) => {
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative flex min-h-screen w-full items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Vibrant%20stylized%20comic%20book%20illustration%20collage%20of%20many%20diverse%20anime%20manga%20characters%20happily%20reading%20comic%20books%20together%20in%20a%20cozy%20glowing%20room%2C%20energetic%20and%20playful%2C%20warm%20coral%20and%20teal%20color%20palette%20on%20dark%20charcoal%20background%2C%20halftone%20dots%20and%20dynamic%20comic%20speed%20lines%2C%20dramatic%20neon%20rim%20lighting%2C%20cinematic%20depth%2C%20high%20detail%20digital%20painting&width=1600&height=900&seq=hero-178-01&orientation=landscape')",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/70 to-background-50"></div>
      </div>

      <div className="container-site relative z-10 w-full py-32 text-center md:py-40">
        <div className="mx-auto max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-400/40 bg-primary-500/10 px-4 py-1.5 text-xs font-medium text-primary-300">
            <i className="ri-flashlight-fill"></i>
            一起看漫画 · 同看 · 一起追
          </span>

          <h1 className="mt-6 font-heading text-5xl leading-tight text-foreground-950 md:text-7xl">
            一起看漫画，
            <br />
            <span className="bg-gradient-to-r from-primary-400 via-secondary-400 to-accent-400 bg-clip-text text-transparent">
              追更不孤单
            </span>
          </h1>

          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-foreground-600 md:text-lg">
            想找漫画一起看？178漫画网一起看漫画专区，支持同看、一起追，
            热门作品实时同步更新。点开就能和漫友共读，边看边聊，追更路上永远有伴。
          </p>

          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <button type="button" className="btn-primary w-full sm:w-auto" onClick={() => goTo('#hot')}>
              <i className="ri-play-circle-fill text-lg"></i>
              马上开始同看
            </button>
            <button type="button" className="btn-ghost w-full sm:w-auto" onClick={() => goTo('#features')}>
              了解核心玩法
              <i className="ri-arrow-down-line"></i>
            </button>
          </div>

          <div className="mx-auto mt-14 grid max-w-2xl grid-cols-3 divide-x divide-background-300/40 rounded-2xl border border-background-200/70 bg-background-100/60 py-5 backdrop-blur-md">
            <div className="flex flex-col items-center gap-1">
              <span className="font-heading text-2xl text-primary-400 md:text-3xl">6,800+</span>
              <span className="text-xs text-foreground-500">部可同看作品</span>
            </div>
            <div className="flex flex-col items-center gap-1">
              <span className="font-heading text-2xl text-secondary-400 md:text-3xl">120万+</span>
              <span className="text-xs text-foreground-500">漫友同看房间</span>
            </div>
            <div className="flex flex-col items-center gap-1">
              <span className="font-heading text-2xl text-accent-400 md:text-3xl">24h</span>
              <span className="text-xs text-foreground-500">实时同步更新</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 hidden -translate-x-1/2 md:block">
        <button
          type="button"
          onClick={() => goTo('#features')}
          className="flex h-10 w-10 items-center justify-center rounded-full border border-background-300/60 text-foreground-500 transition-colors hover:text-primary-300 cursor-pointer"
          aria-label="向下滚动"
        >
          <i className="ri-arrow-down-s-line text-xl"></i>
        </button>
      </div>
    </section>
  );
}